import React from "react";
import { FlatButton } from "material-ui";

import PassActions from "../../actions/PassActions";
import PassBucketStore from "../../stores/PassBucketStore";

import BaseOverlay from "./overlays/base.jsx";
import SupplementaryDataContentEditor from "./supplementary-data-content-editor.jsx";
import InjectedSelect from "./injected-select.jsx";

const EMAIL_KEY = "$$$email$$$$";

class SupplementaryDataModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dirty: false,
      createData: {
        pass_bucket: null
      },
      updatedData: {}
    };

    this.cancel = this.cancel.bind(this);
    this.submit = this.submit.bind(this);
    this._updateDataValue = this._updateDataValue.bind(this);
  }

  getStyles() {
    return {
      actions: {
        marginTop: 15
      },
      dialogTitle: {
        borderBottom: "none"
      },
      dialogActionsContainer: {
        borderTop: "none"
      },
      create: {
        margin: "0px auto 1.5em",
        maxWidth: "90%",
        width: 320
      }
    };
  }

  cancel() {
    this.props.requestClose();
  }

  submit() {
    let name = this.state.updatedData.name;
    delete this.state.updatedData.name;
    let result = {
      name: name,
      supplementary_data: this.state.updatedData
    };

    if (this.props.isCreatingAtCheckIn) {
      let email = this.state.updatedData[EMAIL_KEY];
      delete this.state.updatedData[EMAIL_KEY];
      result.email = email;
      Object.assign(result, this.state.createData);
    }

    if (this.props.onSubmit) {
      this.props.onSubmit(result);
      return;
    }

    PassActions.edit(this.props.pass.id, result);
    this.props.requestClose();
  }

  _updateDataValue(key, value) {
    let data = Object.assign({}, this.state.updatedData);
    data[key] = value;
    this.setState({ dirty: true, updatedData: data });
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    // if state is dirty, don't overwrite user edits with the interval update
    if (!this.state.dirty) {
      let data = newProps.pass.supplementary_data;
      data.name = newProps.pass.name;

      this.setState({
        updatedData: data
      });
    }
  }

  render() {
    let styles = this.getStyles(),
      { pass, isCreatingAtCheckIn, eventBucketId } = this.props;

    let fields = (
      (
        pass.pass_bucket ||
        PassBucketStore.getPassBucketById(this.state.createData.pass_bucket) ||
        {}
      ).supplementary_data || []
    ).slice();
    fields.splice(0, 0, {
      key: "name",
      required: true,
      label: `Full name to display on pass`
    });

    if (isCreatingAtCheckIn) {
      fields.splice(1, 0, {
        key: EMAIL_KEY,
        required: false,
        label: `Email address`
      });
    }

    return (
      <BaseOverlay
        title={this.state.updatedData.name || pass.name || "Unnamed Pass"}
        titleStyle={styles.dialogTitle}
        actionsContainerStyle={styles.dialogActionsContainer}
        useMuiDefaultStyle={true}
        openImmediately={true}
        actions={[
          <FlatButton label={"Cancel"} onTouchTap={this.cancel} />,
          <FlatButton
            disabled={!this.state.dirty}
            primary={true}
            label={isCreatingAtCheckIn ? "Create pass" : "Submit changes"}
            onTouchTap={this.submit}
          />
        ]}
        modal={true}
        open={true}
        onRequestClose={this.cancel}
      >
        <div>
          {isCreatingAtCheckIn ? (
            <div style={styles.create}>
              <InjectedSelect
                type="pass_buckets"
                value={this.state.createData.pass_bucket}
                eventBucketId={eventBucketId}
                labelFormatter={p => `${p.name}`}
                placeholder="Select pass bucket"
                focus={!this.state.dirty}
                onChange={v =>
                  this.setState({
                    dirty: true,
                    createData: Object.assign(this.state.createData, {
                      pass_bucket: v
                    })
                  })
                }
              />
            </div>
          ) : null}
          <SupplementaryDataContentEditor
            fields={fields}
            data={this.state.updatedData}
            existingImages={
              this.props.person && this.props.person.supplementary_data_images
            }
            updateDataValue={this._updateDataValue}
          />
        </div>
      </BaseOverlay>
    );
  }
}

export default SupplementaryDataModal;



// WEBPACK FOOTER //
// ./src/app/components/partials/supplementary-data-modal.jsx